// JsFromRoutes CacheKey 23fa2840f9b601e42289fda17488fbb8
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/axios";

export const moveInInspections = {
  create: definePathHelper("post", "/move_in/inspections"),
  new: definePathHelper("get", "/move_in/inspections/new"),
};
